import SEO from "../components/SEO";
import PricingPreview from "../sections/PricingPreview";
import FinalCTA from "../sections/FinalCTA";

export default function MarketingPricing() {
  return (
    <div data-testid="marketing-pricing-page">
      <SEO
        title="Pricing"
        description="Simple monthly pricing for ClientDesk VA — Starter, Professional and Business plans for virtual assistants and small teams."
        path="/pricing"
      />
      <PricingPreview />
      <FinalCTA />
    </div>
  );
}
